<template>
  <div class="wrap">
      <div class="logon-header">
        <div class="header-img">
          <img src="../../img/header-img.png" alt="">
        </div>
      </div>
      <div class="login-content" :style="{minHeight:winHeight-200+'px'}">
        <p class="desc">请填写您的信息</p>
        <a href="#" class="moreSea">获取更多查询</a>
        <div class="form">
          <input type="text" class="phone" placeholder="您的手机号码"
                 maxlength="11" v-model="phoneNum"
                 onkeypress="return event.keyCode>=48&&event.keyCode<=57" ng-pattern="/[^a-zA-Z]/"
          >
          <div class="code">
            <input type="text" class="" maxlength="4" placeholder="短信验证码"
                   onkeypress="return event.keyCode>=48&&event.keyCode<=57" ng-pattern="/[^a-zA-Z]/"
                   ref="enterCode"
                   v-model="isCode"
            >
            <input type="submit" value="发送验证码" v-on:click="sendCode" ref="codeBtn">
          </div>
          <input type="submit" value="提交" class="allSub" v-on:click="login">
        </div>
      </div>
    <footerDiv></footerDiv>

  </div>

</template>

<script>
  import footerDiv from '../component/footer'

  export default {
    data () {
      return {
        phoneNum: null,
        Code:'',
        time: 60, // 发送验证码倒计时
        isCode:'',
        msg:'',
        winHeight:window.screen.height,
      }
    },
    components: {
      footerDiv
    },
    created:function(){

        var that = this
        $.post('http://www.gzmeize.com/ziyu.php?Action=sendcode', function(msg) {
          that.Code = JSON.parse(msg).send_code
        })
      $.post('http://www.gzmeize.com/ziyu.php?Action=logout', function(msg) {
       // console.log(msg)
      })

        },
    methods: {
      isPhone (phone) {         //手机号正则
        var phoneReg = /(^1[3|4|5|7|8]\d{9}$)|(^09\d{8}$)/
        if (!phoneReg.test(phone)) {
          this.phoneNum = ''
          alert('请输入有效的手机号码！')
          return false
        }
        return true
      },
      sendCode () { //发送验证码
        var that = this

        if(this.isPhone(this.phoneNum)){
          that.countDown()
          $.post('http://www.gzmeize.com/ziyu.php?Action=weiyuebao', {mobile:that.phoneNum,send_code:that.Code}, function(msg) {
            alert(msg)
            if(msg == '提交成功'){

            }
          })
        }
      },
      login(){ //登录
        var that = this

        if(this.isCode == '' && this.isCode.length != 4){
          alert('请输入4位验证码')
          return
        }
//        $.ajax({
//          url:'http://www.gzmeize.com/ziyu.php?Action=login',
//          data:{mobile:that.phoneNum,mobile_code:that.isCode},
//          xhrFields: {
//            withCredentials: true
//          }
//        }).done(function(data){
//         // console.log(data)
//        })
        $.post('http://www.gzmeize.com/ziyu.php?Action=login', {mobile:that.phoneNum,mobile_code:that.isCode},function(data) {
          if(JSON.parse(data).msg == '登录成功'){
            window.localStorage.userUserID = JSON.parse(data).userUserID
            that.$router.push({path: './'})
          }else{

            alert(JSON.parse(data).msg)
          }
          //console.log(JSON.parse(data))
        })
      },
      countDown(){
        var that = this
        var el = that.$refs.codeBtn
        let interval = window.setInterval(function() {
          that.time--
          el.value = that.time+'秒再次尝试'
          el.disabled = "disabled"
          if (that.time <= 0) {
            that.time = 10;
            el.disabled = ""
            el.value='短信验证码'
            window.clearInterval(interval);
          }
        }, 1000);
      }
    },
    watch: {
      phoneNum (val){
        if(val.length == 11){
          this.isPhone(val)
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
  @import "../reset"
  @import "./login"
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue